// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Eg9c","consentsList":"PatientConsents_consentsList__jdfaS","consentsListEmpty":"PatientConsents_consentsListEmpty__3nHp8"};